import HttpHelpers from './helpers';

const CurrenciesApiEndpoints = {
  getCurrencies: () => {
    return HttpHelpers.unAuthenticatedAxios
      .get('currency')
      .then((response) => response.data);
  },
};

export default CurrenciesApiEndpoints;
